

























// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBaseFlux from '@/components/flux/edit/EditBaseFlux.vue'
import { getDefaultAloFlux, AloFlux } from '@/models/alo/AloFlux'
import {FluxRestrictFlag} from '@/enum/FluxRestrictFlag'
import { toSubArray } from '@/utils/groupBy'
import * as rules from '@/utils/validationRules'
//@ts-ignore
import VJsoneditor from 'v-jsoneditor/src/index'

@Component({
  name: 'EditSpecifique',
  components:{EditBaseFlux,VJsoneditor}
})
export default class EditSpecifique extends Vue {
    
  private flux:AloFlux = getDefaultAloFlux()
  private showDrawer = false
  private saving = false  

  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }

  edit(item:AloFlux) {    
    this.flux = (this.$refs.baseEdit as EditBaseFlux).edit(item)
  }  
  
  get json(){
    return JSON.parse(this.flux.fspJsonParam)
  }

  set json(newValue){
    this.flux.fspJsonParam = JSON.stringify(newValue)
  }

}
